import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [query, setQuery] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      navigate(`/category/quanxin?q=${encodeURIComponent(query.trim())}`);
    }
  };

  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20minimalist%20abstract%20geometric%20composition%20with%20warm%20terracotta%20and%20cream%20toned%20layered%20shapes%2C%20soft%20diffused%20lighting%2C%20elegant%20gradient%20from%20warm%20beige%20to%20soft%20coral%2C%20clean%20modern%20aesthetic%2C%20no%20text%2C%20subtle%20texture%2C%20editorial%20style%2C%20high%20resolution%2C%20peaceful%20atmosphere&width=1920&height=960&seq=hero-bg-fanhao-01&orientation=landscape"
        alt="番号本 Hero 背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 mb-4 leading-tight">
            {t('home:heroTitle')}
          </h1>
          <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-xl mx-auto leading-relaxed">
            {t('home:heroSubtitle')}
          </p>

          <form onSubmit={handleSearch} className="flex flex-col sm:flex-row items-center gap-3 max-w-lg mx-auto">
            <div className="relative flex-1 w-full">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-search-line text-base text-foreground-400"></i>
                </div>
              </div>
              <input
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder={t('home:heroPlaceholder')}
                className="w-full pl-10 pr-4 py-3.5 rounded-full bg-background-50/95 text-foreground-900 text-sm placeholder:text-foreground-400 border border-transparent focus:outline-none focus:ring-2 focus:ring-primary-400 transition-shadow"
              />
            </div>
            <button
              type="submit"
              className="whitespace-nowrap px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer w-full sm:w-auto"
            >
              {t('home:heroSearchBtn')}
            </button>
          </form>

          <div className="flex items-center justify-center gap-4 mt-8">
            <span className="text-xs text-background-50/60">热门搜索：</span>
            {['SSIS-001', 'MIDV', 'IPX', '排行榜'].map((term) => (
              <button
                key={term}
                onClick={() => {
                  setQuery(term);
                }}
                className="text-xs text-background-50/70 hover:text-background-50 border border-background-50/20 rounded-full px-3 py-1 transition-colors cursor-pointer whitespace-nowrap"
              >
                {term}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 flex items-center justify-center animate-bounce">
          <i className="ri-arrow-down-s-line text-background-50/60 text-lg"></i>
        </div>
      </div>
    </section>
  );
}